import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { StandSoilCreateDto, StandSoilUpdateDto } from '../proxy/geographic/dtos/stand-soil';
import { STANDSOIL_CONFIG, STANDSOIL_FIELDS } from './stand-soil.config';
import { BaseHierarchicalCrudComponent, GenericForm, ICrudService, ZnHierarchicalViewComponent } from '@zendra/shared';
import { StandSoilService } from '../proxy/geographic/controllers';
import { StandSoilProjectionPlanningOrchestratorService } from 'orchestrator';
import { GetStandSoilProjectionListInputDto, StandSoilProjectionDto, StandSoilProjectionExcelDownloadDto } from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/stand-soils/models';

@Component({
  selector: 'app-stand-soil',
  imports: [ZnHierarchicalViewComponent, GenericForm],
  providers: [ListService, StandSoilService, ConfirmationService],
  templateUrl: './stand-soil.html',
  styleUrl: './stand-soil.scss',
})
export class StandSoil extends BaseHierarchicalCrudComponent<StandSoilProjectionDto, StandSoilCreateDto, StandSoilUpdateDto, StandSoilProjectionExcelDownloadDto> {
  private readonly geographicService = inject(StandSoilService);
  private readonly orchestratorService = inject(StandSoilProjectionPlanningOrchestratorService);

  service: ICrudService<StandSoilProjectionDto, StandSoilCreateDto, StandSoilUpdateDto, StandSoilProjectionExcelDownloadDto> = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.geographicService.deleteByIds(ids),
    getList: (query: GetStandSoilProjectionListInputDto) => this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(this.orchestratorService, 'standSoilId'),
  };
  config = STANDSOIL_CONFIG;
  fields = STANDSOIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandSoilProjectionDto): StandSoilUpdateDto {
    return {
      standSoilArea: data.standSoilArea,
      standSoilPercentage: data.standSoilPercentage,
      isMainSoil: data.isMainSoil,
      standLocationId: data.standLocationId,
      soilUnitId: data.soilUnitId,
      strategicCommercialZoneId: data.strategicCommercialZoneId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string { return 'StandSoil'; }
}
